var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 131,
    viewBox: "0 0 129 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8161 35.1521L77.632 13.0625M75.9331 27.7889L89.5268 19.8593",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0161 62.4301V82.8205",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8208 72.6253H74.2113",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.323 127C117.009 127 109.645 122.979 105.103 116.805C100.56 122.979 93.1971 127 84.8823 127C76.5675 127 69.2043 122.979 64.6617 116.805C60.1192 122.979 52.7559 127 44.4411 127C36.1263 127 28.7631 122.979 24.2206 116.805C19.678 122.979 12.3148 127 4 127",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9967 108.875C37.6443 111.628 41.4959 113.406 46.265 113.406C53.7981 113.406 55.8032 100.946 64.5824 100.946C73.3617 100.946 75.3667 113.406 82.8999 113.406C87.0799 113.406 90.9994 112.172 94.3639 110.008L94.4658 109.872V98.3741L105.556 75.3215C109.294 71.4133 109.351 63.6649 103.891 60.3685L67.8449 38.596C65.466 37.1573 62.6 37.1573 60.2098 38.596L24.1639 60.3685C18.7038 63.6649 18.7491 71.4247 22.4987 75.3328L33.5889 98.3854V108.32L34.008 108.887L33.9967 108.875Z",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0568 35.5146C39.5811 35.7525 39.06 35.8771 38.5275 35.8771H36.0807C33.7698 35.8771 31.9006 34.5744 31.9006 32.3428V24.3452C31.9006 22.1249 33.7698 20.3237 36.0807 20.3237H38.6975V17.8089C38.6975 15.5886 40.5666 13.7874 42.8775 13.7874H52.2685V8.02146C52.2685 5.80116 54.1489 4 56.4485 4H71.5715C73.8824 4 75.7515 5.80116 75.7515 8.02146V13.7874H85.1538C87.4534 13.7874 89.3339 15.5886 89.3339 17.8089V20.3237H91.9506C94.2502 20.3237 96.1307 22.1249 96.1307 24.3452V32.3428C96.1307 34.5631 94.069 36.3642 91.7694 36.3642H90.2514C89.719 36.3642 89.1866 36.2396 88.7221 36.0017L76.9749 29.2049L70.5633 25.4213C66.3945 22.9292 61.784 22.9632 57.468 25.3987L51.6907 28.7744L40.0455 35.5146H40.0568Z",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstCall);
export default __webpack_public_path__ + "static/media/first-call.6d6cfaac386d58c927ff016cbc9396fd.svg";
export { ForwardRef as ReactComponent };